import App from './App.svelte';
import 'bootstrap/dist/css/bootstrap.min.css';
const app = new App({
    target: document.body,
    props: {
        url: window.location.pathname
    }
});
if (window.location.pathname == "/sites") {
    const fetchImage = (async () => {
        const response = await fetch("/sites");
        response.text()
            .then(resp => {
        });
        return response.text();
    })();
}
export default app;
